<template>
  <!--확약서 작성 절차-->
  <div class="checkReserve_step_wrap">
    <h4 class="stitle1 tleft mb10">확약서 작성절차</h4>
    <div class="checkReserve_step">
      <ul>
        <li class="cr_box">
          <div class="cr_step_box">
            <ul>
              <li class="sprite_img_reserve05 step01">확약서 작성하여 인쇄</li>
              <li>확약서 작성하여 인쇄</li>
            </ul>
          </div>
        </li>
        <li class="cr_arrow">
          <p class="sprite_img_reserve05 cr_arrow">화살표</p>
        </li>
        <li class="cr_box">
          <div class="cr_step_box">
            <ul>
              <li class="sprite_img_reserve05 step02">기관장 직인날인</li>
              <li>기관장 직인날인</li>
            </ul>
          </div>
        </li>
        <li class="cr_arrow">
          <p class="sprite_img_reserve05 cr_arrow">화살표</p>
        </li>
        <li class="cr_box">
          <div class="cr_step_box">
            <ul>
              <li class="sprite_img_reserve05 step03">팩스발송(031-696-8421)</li>
              <li>팩스발송(031-696-8421)</li>
            </ul>
          </div>
        </li>
        <li class="cr_arrow">
          <p class="sprite_img_reserve05 cr_arrow">화살표</p>
        </li>
        <li class="cr_box">
          <div class="cr_step_box">
            <ul>
              <li class="sprite_img_reserve05 step04">확약서 승인(SMS발송)</li>
              <li>확약서 승인(SMS발송)</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!--//확약서 작성 절차-->
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.checkReserve_step_wrap {
  width: 100%;
  display: block;
  padding-bottom: 10px;
}
.checkReserve_step {
  width: calc(100% - 2px);
  margin-bottom: 30px;
  box-shadow: 0px 2px 5px 3px #f8f8f8;
  border: 1px solid #ddd;
  text-align: center;
  padding: 10px 0px;
}
.checkReserve_step > ul {
  display: flex;
  justify-content: space-between;
}
.checkReserve_step ul {
  margin: 0 auto;
}
.checkReserve_step ul li.cr_box {
  width: 19%;
}
.checkReserve_step ul li.cr_arrow {
  width: 8%;
}
.checkReserve_step div.cr_step_box {
  display: block;
  text-align: center;
}
.sprite_img_reserve05 {
  display: inline-block;
  box-sizing: border-box;
  background-image: url('@/assets/images/page/img_reserve01.png');
  background-repeat: no-repeat;
  background-size: 500px 500px;
  font-size: 0px;
  text-indent: -99999px;
  line-height: 0;
}
.step01 {
  width: 50px;
  height: 59px;
  background-position: 0px -165px;
}
.step02 {
  width: 52px;
  height: 59px;
  background-position: -60px -165px;
}
.step03 {
  width: 52px;
  height: 59px;
  background-position: -122px -165px;
}
.step04 {
  width: 50px;
  height: 59px;
  background-position: -183px -165px;
}
.cr_arrow {
  width: 45px;
  height: 39px;
  background-position: 0px -234px;
  margin: 5px 0px;
}
.chReserve {
  width: 90px;
  height: 80px;
  background-position: -45px -230px;
  margin: 0 0 0 10px;
}

@media all and (max-width: 540px) {
  .checkReserve_step div.cr_step_box {
    font-size: 12px;
  }

  .sprite_img_reserve05 {
    background-size: 200px 200px;
  }
  .step01 {
    width: 21px;
    height: 26px;
    background-position: 0px -66px;
  }
  .step02 {
    width: 23px;
    height: 26px;
    background-position: -22px -65px;
  }
  .step03 {
    width: 21px;
    height: 26px;
    background-position: -49px -65px;
  }
  .step04 {
    width: 21px;
    height: 26px;
    background-position: -70px -65px;
  }
  .cr_arrow {
    width: 20px;
    height: 20px;
    background-position: 0px -90px;
    margin: 5px 0px;
  }
  .chReserve {
    width: 40px;
    height: 40px;
    background-position: -20px -90px;
    margin: 0 0 0 10px;
  }
}
</style>
